import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPatients(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11 13h1.854c1.16 0 2.123-1.015 1.676-2.085-1.01-2.42-3.38-3.139-5.197-2.156M7.667 4.667a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0M13 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-5.471 8.667h-4.39c-1.158 0-2.11-1.003-1.736-2.098 1.48-4.314 6.38-4.314 7.86 0 .375 1.095-.577 2.098-1.734 2.098"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPatients);
export default ForwardRef;
